import store from "../store/index";
import {
    TURNITIN_API,
    GET_SIMILARITY_EULA,
    ACCEPT_SIMILARITY_EULA,
    GET_SIMILARITY_VIEWER_URL
} from "../constants/urls";
import ApiHelpers from "../helpers/ApiHelpers";

// Served by TurnitinController, whose routes still sit under /assignment,
// so the existing prefix is reused rather than duplicated.
export const turnitinService = {
    getSimilarityEula, acceptSimilarityEula, getSimilarityViewerUrl
};

async function getSimilarityEula(lang = "en-US") {
  let body = await ApiHelpers.makeAPICall(
    store.state.appState.apiURL + TURNITIN_API + GET_SIMILARITY_EULA + '?lang=' + lang,
    "GET",
    null,
    false
  );
  return body?.json();
}

async function acceptSimilarityEula(version, language) {
  let requestBody = JSON.stringify({ version: version, language: language });
  let body = await ApiHelpers.makeAPICall(
    store.state.appState.apiURL + TURNITIN_API + ACCEPT_SIMILARITY_EULA,
    "POST",
    requestBody,
    false
  );
  return body?.json();
}

async function getSimilarityViewerUrl(contentID, userId = null, turnitinSubmissionId = null) {
  const queryParams = new URLSearchParams();

  if (userId) {
    queryParams.append("userId", userId);
  }

  if (turnitinSubmissionId) {
    queryParams.append("turnitinSubmissionId", turnitinSubmissionId);
  }

  const queryString = queryParams.toString();
  const viewerUrl = GET_SIMILARITY_VIEWER_URL.replace("{{contentID}}", contentID);

  let body = await ApiHelpers.makeAPICall(
    store.state.appState.apiURL + TURNITIN_API + viewerUrl + (queryString ? `?${queryString}` : ''),
    "GET",
    null,
    false
  );
  return body?.json();
}
